import { useQuery } from "@tanstack/react-query"

import { usePartnerCode } from "@/features/PartnerCode"

import { bffApi } from "../apiClient"
import formatStartDate from "../helpers/formatStartDate"
import { BookingLength } from "../models"
import queryKeys from "../queryKeys"

const useBookingLengths = (
  resortId: number | undefined,
  categoryId: number | undefined,
  arrivalDate: Date
) => {
  const formattedDate = formatStartDate(arrivalDate)
  const { partnerCode } = usePartnerCode()

  return useQuery<BookingLength[]>({
    queryKey: queryKeys.bookingLengths(
      resortId,
      categoryId,
      formattedDate,
      partnerCode
    ),
    queryFn: async () => {
      const res = await bffApi.get<{ bookingLengths: BookingLength[] }>(
        `/booking-lengths`,
        {
          params: {
            resortId,
            categoryId,
            arrivalDate: formattedDate,
            partnerCode,
          },
        }
      )
      return res.data.bookingLengths
    },
    enabled: Boolean(resortId) && Boolean(categoryId) && Boolean(arrivalDate),
  })
}

export default useBookingLengths
